// extracted by mini-css-extract-plugin
module.exports = {"Component":"DataTableLocations_Component__2wji8"};